import PubQuoteEditService from '@/services/pubQuoteEdit.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async saveSalesRepQuote({commit}, quoteData) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.saveSalesRepQuote(quoteData);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            commit('setLoading', false, { root: true })
            throw e
        }
    },
    async saveQuoteItem({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.saveQuoteItem(payload);
            commit('setLoading', false, { root: true })

            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async applyPromotionToQuoteItem({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.applyPromotionToQuoteItem(payload);
            commit('setLoading', false, { root: true })

            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async populateNewQuote({commit}, payload) {
        try {

            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.populateNewQuote(payload);
            commit('setLoading', false, { root: true })

            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async populateQuoteEditDataForSalesRep({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.populateQuoteEditDataForSalesRep(id);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async populateQuoteEditDataForInternalRep({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            // console.log('quoteid:' + id)
            const response = await PubQuoteEditService.populateQuoteEditDataForInternalRep(id);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async populateQuoteEditDataForInternalRepWithoutLoading({commit}, id) {
        try {
            const response = await PubQuoteEditService.populateQuoteEditDataForInternalRep(id);
            return response
        } catch (e) {
            console.log(e)
            return e
        }
    },
    async populateQuoteEditLookups({commit}, facilityIdAndTerritoryIdPayload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            // console.log('terr:' + facilityId)
            const response = await PubQuoteEditService.populateQuoteEditLookups(facilityIdAndTerritoryIdPayload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    //Quote Item Template Form Related
    async getQuoteTemplateForQuote({commit}, templateSearch) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            // console.log('terr:' + facilityId)
            const response = await PubQuoteEditService.getQuoteTemplateForQuote(templateSearch);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async saveQuoteTemplateForQuote({commit}, template) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            // console.log('terr:' + facilityId)
            const response = await PubQuoteEditService.saveQuoteTemplateForQuote(template);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },

    //End Quote Item Template Form Related
    
    //Quote DMS Configurator Related
    async getDmsConfiguratorItems({commit}, quoteId) {
        try {
            // commit('setLoading', true, { root: true })
            // commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.getDmsConfiguratorItems(quoteId);
            // commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async saveDmsItemsToQuote({commit}, dmsItems) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.saveDmsItemsToQuote(dmsItems);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async getDmsItemPrice({commit}, {quoteId, itemNumber, catalogNum, quantity}) {
        try {
            const response = await PubQuoteEditService.getDmsItemPrice(quoteId, itemNumber, catalogNum, quantity);
            return response
        } catch (e) {
            return e
        }
    },
    //End Quote DMS Configurator Related

    // SoldTo Search
    async getSoldToListByFacility({commit}, facilityId) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubQuoteEditService.getSoldToListByFacility(facilityId);
            commit('setLoading', false, { root: true })

            return response
        } catch (e) {
            commit('setLoading', false, { root: true })
            commit('setError', e, { root: true })
            throw e
        }
    },

    async addQuoteAsOppotunity({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            // console.log('quoteid:' + id)
            const response = await PubQuoteEditService.addQuoteAsOppotunity(id);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async addQuoteContactToSalesforce({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            // console.log('quoteid:' + id)
            const response = await PubQuoteEditService.addQuoteContactToSalesforce(id);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        }
    },

}

const mutations = {
}

export const pubQuoteEdit = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}